import React from 'react'
import { useTheme, CircularProgress } from '@material-ui/core'
import SSButton from 'ui/SSButton'

export default ({
  children,
  loading,
  icon: Icon,
  color = 'primary',
  type = 'submit',
  style,
  ...props
}) => {
  const theme = useTheme()

  return loading ? (
    <div style={{ minWidth: theme.spacing(20), textAlign: 'center' }}>
      <CircularProgress style={style} />
    </div>
  ) : (
    <SSButton
      type={type}
      variant="secondary"
      color={color}
      style={{ minWidth: theme.spacing(20), ...style }}
      {...props}
    >
      {Icon && <Icon style={{ marginRight: theme.spacing(1) }} />}
      {children}
    </SSButton>
  )
}
